// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "meta_ad_ranking_snapshot".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "meta_ad_ranking_snapshot" table (1:1 with a DB row, on the wire). */
export const metaAdRankingSnapshotAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    adAccountId: z.string(),
    metaCampaignId: z.string(),
    metaAdId: z.string(),
    window: z.string(),
    asOf: z.string(),
    qualityRanking: z.string().nullable(),
    engagementRateRanking: z.string().nullable(),
    conversionRateRanking: z.string().nullable(),
    impressions: z.number(),
    fetchedAt: z.string().datetime(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=metaAdRankingSnapshot.js.map